import { Link } from "react-router-dom";
import useSEO from "../hooks/useSEO";

const LAST_UPDATE = "15 février 2026";

export default function Cookies() {
  useSEO({
    title: "Politique relative aux cookies",
    description: "Description détaillée des cookies utilisés par DemkaBiz et de vos options de gestion.",
  });
  const reset = () => { try { localStorage.removeItem("demka_cookie_consent_v1"); window.location.reload(); } catch { /* ignore */ } };
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-testid="cookies-page">
      <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">Cookies</p>
      <h1 className="font-display font-bold text-4xl sm:text-5xl text-foreground tracking-tight mb-2">Politique relative aux cookies</h1>
      <p className="text-sm text-muted-foreground mb-10">Dernière mise à jour : {LAST_UPDATE}</p>

      <div className="prose prose-stone max-w-none space-y-2">
        <h2 className="font-display font-semibold text-2xl text-foreground mt-4">1. Qu'est-ce qu'un cookie ?</h2>
        <p>Un cookie est un petit fichier texte déposé sur votre appareil lorsque vous visitez un site web. Il permet au site de mémoriser certaines informations (préférences, session de connexion, etc.).</p>

        <h2 className="font-display font-semibold text-2xl text-foreground mt-8">2. Les cookies utilisés par DemkaBiz</h2>
        <div className="overflow-x-auto my-4">
          <table className="w-full text-sm border-collapse">
            <thead className="bg-secondary/60">
              <tr>
                <th className="text-left p-3 border border-primary/10">Nom</th>
                <th className="text-left p-3 border border-primary/10">Finalité</th>
                <th className="text-left p-3 border border-primary/10">Type</th>
                <th className="text-left p-3 border border-primary/10">Durée</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border border-primary/10 font-mono text-xs">demka_token</td>
                <td className="p-3 border border-primary/10">Authentification (vous garder connecté)</td>
                <td className="p-3 border border-primary/10"><span className="text-primary font-medium">Essentiel</span></td>
                <td className="p-3 border border-primary/10">24h</td>
              </tr>
              <tr>
                <td className="p-3 border border-primary/10 font-mono text-xs">access_token</td>
                <td className="p-3 border border-primary/10">Jeton de session sécurisé (httpOnly)</td>
                <td className="p-3 border border-primary/10"><span className="text-primary font-medium">Essentiel</span></td>
                <td className="p-3 border border-primary/10">24h</td>
              </tr>
              <tr>
                <td className="p-3 border border-primary/10 font-mono text-xs">demka_cookie_consent_v1</td>
                <td className="p-3 border border-primary/10">Mémoriser vos préférences de cookies</td>
                <td className="p-3 border border-primary/10"><span className="text-primary font-medium">Essentiel</span></td>
                <td className="p-3 border border-primary/10">13 mois</td>
              </tr>
              <tr>
                <td className="p-3 border border-primary/10 font-mono text-xs">demka_dismissed_ann</td>
                <td className="p-3 border border-primary/10">Mémoriser les annonces fermées</td>
                <td className="p-3 border border-primary/10"><span className="text-primary font-medium">Essentiel</span></td>
                <td className="p-3 border border-primary/10">13 mois</td>
              </tr>
              <tr>
                <td className="p-3 border border-primary/10 font-mono text-xs">Mesure d'audience interne</td>
                <td className="p-3 border border-primary/10">Statistiques anonymes (pages vues)</td>
                <td className="p-3 border border-primary/10"><span className="text-accent font-medium">Optionnel</span></td>
                <td className="p-3 border border-primary/10">Sans cookie persistant</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-sm text-muted-foreground">Aucun cookie publicitaire ni de pistage tiers n'est utilisé sur DemkaBiz.</p>

        <h2 className="font-display font-semibold text-2xl text-foreground mt-8">3. Vos choix</h2>
        <p>Lors de votre première visite, une bannière vous propose d'accepter ou de refuser les cookies non essentiels. Vous pouvez à tout moment modifier votre choix :</p>
        <ul>
          <li>en cliquant sur le bouton ci-dessous;</li>
          <li>via les paramètres de votre navigateur (vous pouvez bloquer ou supprimer les cookies à tout moment).</li>
        </ul>
        <div className="mt-6">
          <button onClick={reset} className="btn-primary" data-testid="cookie-reset">Modifier mes préférences cookies</button>
        </div>

        <h2 className="font-display font-semibold text-2xl text-foreground mt-8">4. Conséquences du refus</h2>
        <p>Les cookies essentiels ne peuvent pas être désactivés sans empêcher la Plateforme de fonctionner correctement (notamment la connexion à votre compte).</p>

        <h2 className="font-display font-semibold text-2xl text-foreground mt-8">5. Plus d'informations</h2>
        <p>Pour en savoir plus sur le traitement de vos renseignements, consultez notre <Link to="/confidentialite" className="text-primary">Politique de confidentialité</Link>.</p>
      </div>
    </div>
  );
}
